import { useMutation } from "@apollo/client";
import gql from "graphql-tag";
import React from "react";
import ReactDocumentTitle from "../../../components/ReactDocumentTitle";
import CompanyBrandAddForm from "../../../components/company/CompanyBrandAddForm";
import FormWrapper from "../../../components/licenseType/FormWrapper";
import AppLayout from "../../../layouts/AppLayout";
import { BrandCompanyAddInput } from "../../../schema";
import BackLink from "../../../ui/BackLink";
import FormTitle from "../../../ui/FormTitle";
import { reverse } from "../../../urls";
import { handleError, handleSuccess } from "../../../utils/Apollo";

export default function BrandAddCompanyScene() {
  const [submit] = useMutation(mutation);
  const backLink = reverse("licensees_list");

  const onFormSubmit = React.useCallback(
    (formData) => {
      const data: BrandCompanyAddInput = {
        company: {
          name: formData.name,
          country: formData.country,
          description: formData.description,
          contact: formData.contact,
        },
        licenseTypeId: formData.license.typeId,
        licenseVersion: formData.license.version,
        licenseStartDate: formData.license.start,
        licenseEndDate: formData.license.end,
        licenseSeats: formData.license.seats,
        licenseFee: {
          amount: formData.license.fee.amount,
          currency: formData.license.fee.currency,
        },
      };
      submit({
        variables: { data },
      }).then(
        (result) =>
          handleSuccess(
            "Company added",
            reverse("licensee_profile", {
              id: result.data.createLicenseeCompany.id,
            })
          ),
        (apolloError) => handleError(apolloError)
      );
    },
    [submit]
  );

  return (
    <>
      <ReactDocumentTitle title="Add company" />
      <AppLayout className="bg-gray-light">
        <BackLink backLink={backLink} title="Back to list of licensees" />
        <FormTitle>Add company</FormTitle>
        <FormWrapper>
          <CompanyBrandAddForm backLink={backLink} onSubmit={onFormSubmit} />
        </FormWrapper>
      </AppLayout>
    </>
  );
}
const mutation = gql`
  mutation AddFormMutation($data: BrandCompanyAddInput!) {
    createLicenseeCompany(data: $data) {
      id
    }
  }
`;
